
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.75 1.25a2.5 2.5 0 00-2.5 2.5v.5h-3.5a1 1 0 000 2h.5V19.5A1.75 1.75 0 006 21.25h12a1.75 1.75 0 001.75-1.75V6.25h.5a1 1 0 100-2h-3.5v-.5a2.5 2.5 0 00-2.5-2.5h-4.5zm5 3v-.5a.5.5 0 00-.5-.5h-4.5a.5.5 0 00-.5.5v.5h5.5zm-6.5 2h-2v13h11.5v-13h-9.5zm1.5 2.5a1 1 0 011 1v6a1 1 0 11-2 0v-6a1 1 0 011-1zm5.5 1a1 1 0 10-2 0v6a1 1 0 102 0v-6z","fill":"#282E3E"}})])
          )
        }
      }
    